<template>
  <div class="fish-admin section">
    <h1 class="title">Periods</h1>

    <div class="fishes">
      <article class="fish media" v-for="(periodVal, period) in periods">
        <div class="media-content">
          <h2 class="subtitle">{{period}}</h2>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import fb from 'firebase'
import _ from 'underscore'

export default {
  data: function() {
    return {
      periods: []
    }
  },
  ready: function() {
    window.fb = fb
    window._ = _

    self = this
    fb.database().ref('periods').on('child_added', function(snapshot) {
      self.periods.push(snapshot.key)
    })

  },
}
</script>



/** WEBPACK FOOTER **
 ** Periods.vue?182baa19
 **/